export default "<app-head></app-head>"